import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { DateTime } from 'scaleflow/utils/date-time';

export default class TimelineInitiativesTableDatePickerIndexComponent extends Component {
  @service('organisation') orgService;

  datePickerInstance = null;

  @action
  onDatePickerReady(e) {
    this.datePickerInstance = e;
  }

  @action
  openDatePicker() {
    this.datePickerInstance?.open();
  }

  @action
  handleDateChange(initiative, e) {
    const date = e;
    const yyyy_mm_dd = DateTime.from(date).format('YYYY-MM-DD');
    initiative.startDate = yyyy_mm_dd;
    initiative.save();
  }

  willDestroy() {
    this.datePickerInstance?.destroy();
    this.datePickerInstance = null;
    super.willDestroy(...arguments);
  }
}
